import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Обгортка для захищених маршрутів
 * @param {ReactNode} children - компонент, який треба показати
 * @param {boolean} isAdmin - чи користувач з таблиці admins
 */
const ProtectedRoute = ({ children, isAdmin }) => {
  if (!isAdmin) {
    return <Navigate to="/date" replace />;
  }
  return children;
};

export default ProtectedRoute;